import { navLinks } from "@/mocks/home";

const aboutLinks = ["关于我们", "内容口径", "线索核实流程", "联系我们"];
const legalLinks = ["免责声明", "版权说明", "隐私保护", "侵权投诉"];

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-radar-line text-lg" />
              </span>
              <span className="font-label text-base font-bold text-foreground-900">免费黑料</span>
            </a>
            <p className="mt-4 max-w-sm font-body text-sm leading-relaxed text-foreground-600">
              专注深度内幕挖掘的免费黑料门户。我们把「背后真相」做成可查证、可追踪的内容，少一点情绪，多一点证据。
            </p>
            <p className="mt-4 font-label text-xs leading-relaxed text-foreground-400">
              本站所有内容均基于公开报道与可核实来源整理，仅作信息深挖与呈现。
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-label text-sm font-semibold text-foreground-900">内容栏目</h4>
            <ul className="mt-3 space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="font-body text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-label text-sm font-semibold text-foreground-900">关于我们</h4>
            <ul className="mt-3 space-y-2.5">
              {aboutLinks.map((l) => (
                <li key={l}>
                  <a href="#tip" rel="nofollow" className="font-body text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-label text-sm font-semibold text-foreground-900">合规与边界</h4>
            <ul className="mt-3 space-y-2.5">
              {legalLinks.map((l) => (
                <li key={l}>
                  <a href="#tip" rel="nofollow" className="font-body text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-200 pt-5 sm:flex-row sm:items-center">
          <p className="font-label text-xs text-foreground-500">
            本站不鼓励任何形式的造谣与人身攻击。如内容涉及您本人权利，请通过合规途径与我们联系处理。
          </p>
          <p className="whitespace-nowrap font-label text-xs text-foreground-400">© 2025 免费黑料 · 深挖背后真相</p>
        </div>
      </div>
    </footer>
  );
}